import ResizeObserverLite from 'resize-observer-lite';

export default class ResizeObserver {
    constructor({ element, onChange }) {
        this.element = element;
        this.resizeObserverListener = new ResizeObserverLite(({ width, height }) => {
            onChange(width, height);
        });
    }

    observe() {
        this.resizeObserverListener.observe(this.element);
    }

    disconnect() {
        this.resizeObserverListener.disconnect();
    }
}
